// extracted by mini-css-extract-plugin
export default {"footer":"SubmitFooter_footer__9ryyr","left":"SubmitFooter_left__065yP","right":"SubmitFooter_right__F8hnS"};